/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Component, Fragment } from '@wordpress/element';
import { InspectorControls } from '@wordpress/block-editor';
import { PanelBody, RadioControl, RangeControl } from '@wordpress/components';

/**
 * Inner dependencies.
 */
import ColorOptions from '../../extensions/controls/color-options';
import PaddingControl from '../../extensions/controls/padding-control';
import MarginControl from '../../extensions/controls/margin-control';
import { generateCustomStyleCode } from '../../extensions/custom-styles';

/**
 * Inspector controls
 */
class Inspector extends Component {
	constructor( props ) {
		super( props );
		this.updateStyles = this.updateStyles.bind( this );
	}

	updateStyles( styles ) {
		const { setAttributes, clientId } = this.props;

		setAttributes( { blockClientId: clientId } );
		generateCustomStyleCode( styles, { ...this.props }, true );
		setAttributes( { blockAdvanceOptions: styles } );
	}

	render() {
		const { attributes, setAttributes } = this.props;
		const { layout, columnSize } = attributes;

		return (
			<Fragment>
				<InspectorControls>
					<PanelBody
						/* translators: block settings */
						title={ __( 'Layout options' ) }
					>
						<RadioControl
							title={ __( 'Layout' ) }
							selected={ layout }
							options={ [
								{ label: __( 'Layout 1' ), value: 'layout_1' },
								{ label: __( 'Layout 2' ), value: 'layout_2' },
							] }
							onChange={ ( option ) => {
								setAttributes( { layout: option } );
							} }
						/>
						<RangeControl value={ columnSize } label={ __( 'Columns' ) } min={ 1 } max={ 3 } step={ 1 } onChange={ ( value ) => {
							setAttributes( { columnSize: value } );
						} } />
					</PanelBody>
					<ColorOptions { ...this.props } />
					<PanelBody
						/* translators: block settings */
						title={ __( 'Advance options' ) }
						initialOpen={ false }
					>
						<PaddingControl
							{ ...this.props }
							parentKey="blockAdvanceOptions"
							label={ __( 'Padding' ) }
							property="padding"
						/>
						<hr />
						<MarginControl
							{ ...this.props }
							parentKey="blockAdvanceOptions"
							label={ __( 'Margin' ) }
						/>
					</PanelBody>
				</InspectorControls>
			</Fragment>
		);
	}
}

export default Inspector;
